import { TrackingContextProvider } from '@flock/shared-ui'
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'

type SectionLayoutProps = {
  name: string
  children: React.ReactNode
  backgroundColor?: string
  sidePadding?: string
  verticalPadding?: string
  maxWidth?: string
  fullWidth?: boolean
  columns?: number
  shouldHide?: boolean
}

const SectionLayout = (props: SectionLayoutProps) => {
  const {
    children,
    backgroundColor,
    name,
    sidePadding,
    verticalPadding,
    maxWidth,
    fullWidth,
    columns,
    shouldHide,
  } = props
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))

  const sidePaddingValues = fullWidth ? '0px' : sidePadding
  const maxWidthValue = fullWidth ? '100vw' : maxWidth

  if (isMobile) {
    return (
      <TrackingContextProvider name={name}>
        <Box
          display={shouldHide ? 'none' : 'flex'}
          justifyContent="center"
          sx={{
            pt: verticalPadding || '32px',
            pb: verticalPadding || '32px',
            pl: sidePaddingValues || '32px',
            pr: sidePaddingValues || '32px',
            backgroundColor,
          }}
        >
          <Box sx={{ maxWidth: maxWidthValue || '304px', width: '100%' }}>
            <Grid container spacing={fullWidth ? 0 : 2} columns={columns || 12}>
              {children}
            </Grid>
          </Box>
        </Box>
      </TrackingContextProvider>
    )
  } else if (isTablet) {
    return (
      <TrackingContextProvider name={name}>
        <Box
          display={shouldHide ? 'none' : 'flex'}
          justifyContent="center"
          sx={{
            pt: verticalPadding || '40px',
            pb: verticalPadding || '40px',
            pl: sidePaddingValues || '40px',
            pr: sidePaddingValues || '40px',
            backgroundColor,
          }}
        >
          <Box
            sx={{
              maxWidth: maxWidthValue || '640px',
              width: '100%',
            }}
          >
            <Grid container spacing={fullWidth ? 0 : 4} columns={columns || 12}>
              {children}
            </Grid>
          </Box>
        </Box>
      </TrackingContextProvider>
    )
  } else {
    return (
      <TrackingContextProvider name={name}>
        <Box
          display={shouldHide ? 'none' : 'flex'}
          justifyContent="center"
          sx={{
            pt: verticalPadding || '80px',
            pb: verticalPadding || '80px',
            pl: sidePaddingValues || '40px',
            pr: sidePaddingValues || '40px',
            backgroundColor,
          }}
        >
          <Box
            sx={{
              maxWidth: maxWidthValue || '1120px',
              width: '100%',
            }}
          >
            <Grid container spacing={fullWidth ? 0 : 4} columns={columns || 12}>
              {children}
            </Grid>
          </Box>
        </Box>
      </TrackingContextProvider>
    )
  }
}

SectionLayout.defaultProps = {
  shouldHide: false,
}

export default SectionLayout
